export const environment = {
  production: false,
  development: true,
  isLocal: true,
  name: 'dev',
 base_url: 'https://devmodel6.bay6.ai',
  encryptDecrypt:false,
  
};
